var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHome0(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.09999 1.79999C5.79999 1.19999 6.69999 0.799988 7.59999 0.799988H8.29999C9.19999 0.799988 10.1 1.19999 10.8 1.79999L14.1 4.89999C14.8 5.59999 15.2 6.49999 15.2 7.49999V11.6C15.2 13.6 13.6 15.2 11.6 15.2H4.39999C2.39999 15.2 0.799988 13.6 0.799988 11.6V7.49999C0.799988 6.49999 1.19999 5.59999 1.89999 4.89999L5.09999 1.79999Z",
    fill: "#2B2F34",
    fillOpacity: 0.12
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.6 1.2C5.4 0.4 6.5 0 7.6 0H8.3C9.4 0 10.5 0.4 11.3 1.2L14.6 4.3C15.5 5.1 16 6.3 16 7.5V11.6C16 14 14 16 11.6 16H4.4C2 16 0 14 0 11.6V7.5C0 6.3 0.5 5.2 1.4 4.3L4.6 1.2ZM7.6 1.5C6.9 1.5 6.2 1.8 5.6 2.3L2.4 5.4C1.8 5.9 1.5 6.7 1.5 7.5V11.6C1.5 13.2 2.8 14.4 4.3 14.4H11.5C13.1 14.4 14.3 13.1 14.3 11.6V7.5C14.3 6.7 14 6 13.4 5.4L10.1 2.3C9.6 1.8 8.9 1.5 8.1 1.5H7.6Z",
    fill: "#2B2F34"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.40002 11.6C5.40002 11.2 5.70002 10.8 6.20002 10.8H9.80002C10.2 10.8 10.6 11.1 10.6 11.6C10.6 12 10.3 12.4 9.80002 12.4H6.20002C5.80002 12.4 5.40002 12 5.40002 11.6Z",
    fill: "#2B2F34"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome0);
export default __webpack_public_path__ + "static/media/icon_home_0.2971b34c371dd3cd5b1e33e79669a212.svg";
export { ForwardRef as ReactComponent };